module.exports = __webpack_public_path__ + "static/img/function-3.1a8896b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/function-3.png
// module id = jUtY
// module chunks = 0